// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"project-breadcrumbs_breadcrumbs__wXxTx"};